import { createFileRoute } from "@tanstack/react-router";

import Receivables from "@/features/company/receivables";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/ausgangsrechnungen",
)({
  component: ReceivablesPage,
  staticData: {
    breadcrumb: ["receivables.link"],
  },
});

function ReceivablesPage() {
  return (
    <div className="flex-1 px-4 pb-4 h-full">
      <Receivables />
    </div>
  );
}
